const UNKNOWN_VERSION = 'unknown';
const isValidVersionString = (version) => /^\d+\.\d+\.\d+$/.test(version);
export default (url) => {
    try {
        const split = url.split('/');
        const possibleVersion = split[split.length - 2];
        return isValidVersionString(possibleVersion)
            ? possibleVersion
            : UNKNOWN_VERSION;
    }
    catch (e) {
        return UNKNOWN_VERSION;
    }
};
//# sourceMappingURL=getAppVersion.js.map